module.exports = __webpack_public_path__ + "img/e1aa547.jpg";